import React, { createContext, useEffect, useState } from "react";
import { loggedIn as fetchLoggedIn } from "../services/AuthServices";
import { setSocketIdentity } from "../socket";

const AuthContext = createContext();

const getOrCreateAnonId = () => {
    let id = localStorage.getItem('anon_id');
    if (!id) {
        if (typeof crypto !== 'undefined' && crypto.randomUUID) {
            id = crypto.randomUUID();
        } else {
            id = Math.random().toString(36).substring(2) + Date.now().toString(36);
        }
        localStorage.setItem('anon_id', id);
    }
    return id;
};

function AuthContextProvider(props) {
    const [loggedIn, setLoggedIn] = useState(undefined);
    const [userId, setUserId] = useState(null);
    const [user, setUser] = useState(null);
    const [authLoading, setAuthLoading] = useState(false);
    
    const [anonId, setAnonId] = useState(getOrCreateAnonId());

    const getLoggedIn = async () => {
        try {
            setAuthLoading(true);

            const loggedInRes = await fetchLoggedIn();

            if (loggedInRes.loggedIn && loggedInRes.user) {
                setLoggedIn(true);
                setUserId(loggedInRes.user._id);
                setUser(loggedInRes.user);
            } else {
                setLoggedIn(false);
                setUserId(null);
                setUser(null);
            }
        } catch (error) {
            console.error('Error fetching loggedIn status:', error);
            setLoggedIn(false);
            setUserId(null);
            setUser(null);
        } finally {
            setAuthLoading(false);
        }
    };

    useEffect(() => {
        getLoggedIn();
    }, []);

    // The server identifies a socket from the auth cookie present at handshake
    // time, and logging in/out never reloads the page — so the socket has to be
    // told when the session changes or it stays bound to the previous identity.
    useEffect(() => {
        if (loggedIn === undefined) return; // auth not resolved yet
        setSocketIdentity(userId);
    }, [loggedIn, userId]);

    return (
        <AuthContext.Provider
            value={{
                loggedIn,
                getLoggedIn,
                userId,
                user,
                setUser,
                authLoading,
                anonId,
            }}
        >
            {props.children}
        </AuthContext.Provider>
    );
}

export default AuthContext;
export { AuthContextProvider };